<template>
    <rkm-modal
        extraLarge
        ref="Modal"
        title="Cadastro de lista"
    >

        <rkm-alert color="success" v-if="item">
            <strong>Composição:</strong> <span class="pr-2">{{ item.descricao }}</span>
            <strong>Sexo:</strong> <span class="pr-2">{{ item.sexo }}</span>
            <strong>Idade:</strong> <span>{{ item.idadeInicial }}-{{ item.idadeFinal }} {{ item.tipoIdade }}</span>
        </rkm-alert>

        <Form
            :data="data"
            :index="index"
            :item="item"
            @save="handleExit"
            ref="Form"
        />

        <template v-slot:footer="{ cancel }">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

export default {
    components: { Form },
    data: () => ({
        index: null,
        item: [],
    }),
    methods: {
        open(index, item) {

            this.index = index
            this.item = item

            this.$refs.Modal.show()
        },
        handleExit(data) {

            this.$emit('save', data)
        },
    },
    props: {
        data: { type: Object, required: true },
    }
}
</script>